import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { parseStringToDate } from "../../../helpers";
import { backButtonHandler, getSetupDetails } from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";
import StripePayment from "../../Components/StripePayment";

const SetupWizardTen = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { account, purchasedPlans } = useSelector(
    (state) => state.authReducer.setup_wizard_details
  );

  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    dispatch(getSetupDetails(9));
  }, []);

  const finalAmountCon = () => {
    const accPurchasedPlan = account?.merchant?.merchant_purchased_plans;
    const exp =
      accPurchasedPlan?.promo_code && accPurchasedPlan?.promo_code != ""
        ? accPurchasedPlan?.total_cost ?? 0
        : accPurchasedPlan?.cost;

    let ordrrCost = 0;
    if (
      purchasedPlans &&
      purchasedPlans.length > 0 &&
      purchasedPlans.findIndex((p) => p.id == 5) > -1
    ) {
      ordrrCost = parseFloat(
        purchasedPlans?.[purchasedPlans.findIndex((p) => p.id == 5)]?.cost
      );
    }
    if (
      purchasedPlans &&
      purchasedPlans.length > 0 &&
      purchasedPlans.findIndex((p) => p.id == 6) > -1
    ) {
      ordrrCost = parseFloat(
        purchasedPlans?.[purchasedPlans.findIndex((p) => p.id == 6)]?.cost
      );
    }
    const priceVal = parseFloat(exp) + parseFloat(ordrrCost);
    let stringPriceVal = `${priceVal}`;
    stringPriceVal = stringPriceVal.split(".");
    return (
      <div className="final-cost col">
        <div className="col">
          <label className="final_cost">
            <small>$</small>
            <strong>{priceVal}</strong>
            <small>.{stringPriceVal?.[1] ?? "00"}</small>
          </label>
          <em>
            {" "}
            Next ${priceVal} Payment on{" "}
            {accPurchasedPlan?.expiry_date
              ? parseStringToDate(
                  accPurchasedPlan?.expiry_date,
                  "yyyy-MM-DD",
                  "MMM DD, yyyy"
                )
              : ""}
          </em>
        </div>
      </div>
    );
  };

  const submitBtnHandler = useCallback(
    (value) => {
      setIsSubmit(value);
    },
    [isSubmit]
  );

  return (
    <SWInterface step={9}>
      <div className="steps-content">
        <div className="steps-div_outer frmStripePayment h-100">
          <div className="steps-div d-block">
            <h4 className="event-alert mb-0"> Payment Details</h4>
            <p className="mt-0">
              Please provide your payment details for your ongoing account
              maintenance.
            </p>
          </div>
          <div className="row-fluid pt-4 newForm_sec">
            <div className="col-6">
              <StripePayment
                isSubmit={isSubmit}
                submitBtnHandler={submitBtnHandler}
                purchased_plan={
                  account?.merchant?.merchant_purchased_plans ?? null
                }
              />
            </div>
          </div>

          <div className="select-pricing">
            <div className="left-sec">
              <h2 className="lg-hd"> Payment Today </h2>
              <p className="m-0"> No GST </p>
            </div>
            <div className="right-sec d-flex">
              <div className="left-col pricing-contain">
                <div className="col">
                  <strong> GoGMGo POS </strong>
                  <br />
                  <strong> GoGMGo ERP </strong>
                  <br />
                  <strong> GoGMGo Hive </strong>
                  <br />
                  {purchasedPlans &&
                    purchasedPlans.length > 0 &&
                    purchasedPlans.findIndex((p) => p.id == 5 || p.id == 6) >
                      -1 && (
                      <>
                        <strong> GoGMGo Ordrr </strong>
                        <br />
                      </>
                    )}
                  {account?.merchant?.merchant_purchased_plans
                    ?.additional_users > 0 && (
                    <em>
                      {
                        account?.merchant?.merchant_purchased_plans
                          ?.additional_users
                      }
                      Users
                    </em>
                  )}
                </div>
              </div>

              {finalAmountCon()}
            </div>
          </div>

          <div className="btns row justify-content-end mx-0 px-0 pb-0">
            <button
              id="back"
              className="col-sm-1 mx-0"
              type="button"
              onClick={() => dispatch(backButtonHandler())}
            >
              Back
            </button>
            <button
              id="next"
              className="btn_btnblue mx-0 col-sm-1"
              type="button"
              onClick={() => submitBtnHandler(true)}
            >
              Pay &amp; Finish
            </button>
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardTen;
